import types from "./actionTypes";
import Requester from "../blueprint/svc";
import { getAssetUpdated } from '../global/selectors';
import { setAssetUpdated } from '../global/actions';
const fetch = new Requester();


export const addAssets = (payload, files) => async (dispatch) => {

	let response = await fetch.uploadFileWithProgress(fetch.route.uploadAssets, payload, dispatch, files);

	await dispatch({
		type: types.ADD_ASSET,
		payload: response.asset
	})
	if (response.status) {
		dispatch(setAssetUpdated());
	}

	return response;
}

export const fetchAssets = () => async (dispatch, getState) => {

	try {
		let blueprintId = fetch.getBlueprintID();
		const res = await fetch.get(fetch.route.assetList(blueprintId));

		await dispatch({
			type: types.RESET_ASSETS,
			payload: res.assets,
		})

		return res.assets;

	} catch (err) {
		console.log("err----------->", err)
		return getState().assets;
	}
}

export const deleteAsset = (asset) => async (dispatch) => {

	const res = await fetch.post(fetch.route.deleteAsset, { asset, _id: asset?._id });
	dispatch(setAssetUpdated());
	console.log({ res });
	return res;
}

export const deleteAssetFolder = (asset, id, item) => async (dispatch) => {

	console.log('aseetss-------->', asset)

	const res = await fetch.post(fetch.route.deleteAssetFolder, { asset, blueprintId: id, _id: item?._id });
	dispatch(setAssetUpdated());
	console.log({ res });
	return res

}


export const displayAsset = async (asset, slug) => {
	try {
		const res = await fetch.post(fetch.route.displayAsset, { asset, slug });
		return res;
	} catch (error) {
		console.log('error-->', error)
		return error;
	}

}


export const renameAsset = ({ name, description, _id, blueprintId, parent }) => async (dispatch) => {

	let data = {
		name, _id, blueprintId, parent
	}
	if(description){
		data.description  = description
	}

	const res = await fetch.post(fetch.route.renameAsset, data);
	dispatch(setAssetUpdated());
	return res

}

export const fetchDirectoryAssets = (parent) => async (dispatch) => {

	try {
		let blueprintId = fetch.getBlueprintID();
		const res = await fetch.get(fetch.route.listParentAssets(blueprintId, parent));
		return res;

	} catch (err) {
		return err;
	}
}